import { Routes, Route } from 'react-router-dom'
import Home from './pages/Home'
import SpecialtyPage from './pages/SpecialtyPage'
import CarePlanPage from './pages/CarePlanPage'
import SearchResults from './pages/SearchResults'
import FeedbackAdmin from './pages/FeedbackAdmin'
import './App.css'

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/specialty/:specialtyId" element={<SpecialtyPage />} />
        <Route path="/care-plan/:carePlanId" element={<CarePlanPage />} />
        <Route path="/search" element={<SearchResults />} />
        <Route path="/feedback-admin" element={<FeedbackAdmin />} />
      </Routes>
    </div>
  )
}

export default App
